module.exports = __webpack_public_path__ + "static/Graphik-Medium-Web-05a470cc03bb0be22cb8f75e687f04f8.woff";